// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table td[data-v-58d957da],.table th[data-v-58d957da]{padding:.75 rem;vertical-align:top;border:none!important;background:transparent!important}", ""]);
// Exports
module.exports = exports;
